import { render } from "./NewsDetailsPage.vue?vue&type=template&id=75d8aede&scoped=true&ts=true"
import script from "./NewsDetailsPage.vue?vue&type=script&lang=ts"
export * from "./NewsDetailsPage.vue?vue&type=script&lang=ts"

import "./NewsDetailsPage.vue?vue&type=style&index=0&id=75d8aede&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d8aede"]])

export default __exports__